import { render, staticRenderFns } from "./SelectCommodityPackageModal.vue?vue&type=template&id=43fa1ad9&scoped=true"
import script from "./SelectCommodityPackageModal.vue?vue&type=script&lang=js"
export * from "./SelectCommodityPackageModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCommodityPackageModal.vue?vue&type=style&index=0&id=43fa1ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fa1ad9",
  null
  
)

export default component.exports